import * as React from 'react';

import BaseSaleHistoryLayout from "~/apps/pos/mobile/pages/BaseSaleHistoryLayout";
import DeleteSale from "~/apps/pos/mobile/containers/sales/DeleteSale";

export default function({ saleId }) {
  return (
    BaseSaleHistoryLayout(
      <DeleteSale saleId={saleId} />
    )
  );
};
